import { Modal, Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';

interface RedirectionModalProps {
  show: boolean;
  onCancel: () => void;
  onContinue: () => void;
  url: string;
  imageUrl?: string;
  title?: string;
  cancelText?: string;
  continueText?: string;
  countdown?: number;
}

const extractDomain = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname;
  } catch {
    return url;
  }
};

const RedirectionModal = ({
  show,
  onCancel,
  onContinue,
  url,
  imageUrl = toAbsoluteUrl("/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png"),
  title,
  cancelText,
  continueText,
  countdown,
}: RedirectionModalProps): JSX.Element => {
  const intl = useIntl();
  const domain = extractDomain(url);

  const resolvedTitle = title ?? intl.formatMessage({id: 'REDIRECTION.MODAL.TITLE'});
  const resolvedCancelText = cancelText ?? intl.formatMessage({id: 'CANCEL'});
  const resolvedContinueText = continueText ?? intl.formatMessage({id: 'REDIRECTION.MODAL.CONTINUE'});

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="text-center p-5">

        {/* logo */}
        {imageUrl && (
          <div className="mb-11 mt-4">
            <img
              src={imageUrl}
              alt="Celeste"
              style={{ width: '130px' }}
            />
          </div>
        )}

        <p className="mb-1 fw-bold fs-4">{resolvedTitle}</p>
        <p className="mb-4 fs-5">
          {intl.formatMessage({id: 'REDIRECTION.MODAL.QUESTION'}, {domain: <b>{domain}</b>})}
        </p>

        {/* Countdown timer */}
        {countdown !== undefined && countdown > 0 && (
          <div className="mb-6">
            <p className="text-muted mb-0">
              {intl.formatMessage({id: 'REDIRECTION.MODAL.COUNTDOWN'}, {seconds: countdown})}
            </p>
          </div>
        )}

        <div className="d-flex gap-3 justify-content-center mt-10 mb-5">
          <Button variant="secondary" onClick={onCancel}>
            {resolvedCancelText}
          </Button>
          <Button variant="primary" onClick={onContinue}>
            {resolvedContinueText}
          </Button>
        </div>
      </Modal.Body>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </Modal>
  );
};

export default RedirectionModal;
